import React, { useCallback, useMemo, useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import '../../../../_tslib-7a01aab4.js';
import { a1 as doBetStore, a2 as betDataStore, z as freeBetStore, y as platformMessageStore, Q as userSettingsStore } from '../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import { inputValidationStore } from '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import '../../../core/store/forCrashGame/resultReportStore.js';
import { gameStore } from '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import { AccumulatedPossibleWin } from './accumulatedPossibleWin.js';
import '../../../contexts/TranslationContext.js';
import '../../../contexts/StoreContext.js';
import { useTranslation } from '../../../hooks/useTranslation.js';
import '../../../core/enums/additionalInputValueChangingButtons.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';
import '../../../core/helpers/getAmountWithCurrency.js';
import '../../../core/enums/Currencies.js';
import '../../../core/helpers/setTranslationValues.js';

var BetButton = observer(function (_a) {
    var _b;
    var sectionIndex = _a.sectionIndex, disabled = _a.disabled, isBetsClosed = _a.isBetsClosed, isBetAccepted = _a.isBetAccepted;
    var doBetSectionsData = doBetStore.doBetSectionsData, freeBetMinOdd = doBetStore.freeBetMinOdd, doBetSender = doBetStore.doBetSender, sendCashOut = doBetStore.sendCashOut, handleBetForNextRound = doBetStore.handleBetForNextRound;
    var _c = doBetSectionsData[sectionIndex], isNextRoundBet = _c.isNextRoundBet, freeBetId = _c.freeBetId, betId = _c.betId; _c.isDisabled; _c.isHalfCashOuted;
    var betButtonDisable = betDataStore.betButtonDisable, betsSectionsData = betDataStore.betsSectionsData; betDataStore.setIsAutoBetOpen; var resetAutoBet = betDataStore.resetAutoBet;
    var _d = betsSectionsData[sectionIndex], isLoaderActive = _d.isLoaderActive, isAutoBet = _d.isAutoBet;
    var activeFreeBet = freeBetStore.activeFreeBet; freeBetStore.freeBets;
    var partnerWageringOdd = gameStore.partnerWageringOdd;
    var Bet = TranslationKeys.Bet, Cancel = TranslationKeys.Cancel, MinOdd = TranslationKeys.MinOdd, CashOut = TranslationKeys.CashOut, FreeBets = TranslationKeys.FreeBets, BetForNextRound = TranslationKeys.BetForNextRound;
    var isClosedDoBet = inputValidationStore.validationSections[sectionIndex].isClosedDoBet;
    var bogLineGameTypeData = platformMessageStore.bogLineGameTypeData;
    var t = useTranslation();
    var handleDoBetEvents = useCallback(function (index, halfCashOut) {
        if (!isBetAccepted && isAutoBet) {
            resetAutoBet(index);
        }
        else if (!isBetAccepted && !isBetsClosed) {
            if (bogLineGameTypeData === null || bogLineGameTypeData === void 0 ? void 0 : bogLineGameTypeData.betButtonClick) {
                userSettingsStore.soundService.play(bogLineGameTypeData.betButtonClick);
            }
            doBetSender(index);
        }
        else if (isBetAccepted) {
            sendCashOut(index, betId, halfCashOut);
        }
        else if (!isBetAccepted && isBetsClosed && !betButtonDisable) {
            handleBetForNextRound(index);
        }
    }, [isBetAccepted, isBetsClosed, betButtonDisable, inputValidationStore.validationSections, isAutoBet]);
    var betBtnText = useMemo(function () {
        return isBetAccepted || (!isBetsClosed && isNextRoundBet)
            ? CashOut
            : !isBetAccepted && isBetsClosed && !isNextRoundBet && !betButtonDisable && !isAutoBet
                ? BetForNextRound
                : (!isBetAccepted && isNextRoundBet && isBetsClosed) || (!isBetAccepted && isAutoBet)
                    ? Cancel
                    : activeFreeBet.id || freeBetId
                        ? FreeBets
                        : Bet;
    }, [isBetAccepted, isNextRoundBet, isBetsClosed, betButtonDisable, activeFreeBet, isAutoBet, freeBetId]);
    var freeBetRemainingCount = betBtnText === FreeBets ? activeFreeBet.remainingCount : '';
    var dynamicClassName = useMemo(function () { return (CashOut === betBtnText ? 'cashout' : Cancel === betBtnText ? 'cancel' : !disabled ? ' puls-anim' : ''); }, [betBtnText, disabled]);
    var localRefIsDoBet = useRef();
    var additionalBtnInfo = (!isBetAccepted && activeFreeBet.minOdd && !activeFreeBet.isMinOddNull) ||
        (freeBetId && !((_b = freeBetStore.freeBets.find(function (item) { return +item.id === +freeBetId; })) === null || _b === void 0 ? void 0 : _b.isMinOddNull)) ? (React.createElement("span", { className: 'bet-button-title free-bet' }, " ".concat(t(MinOdd), " x").concat(freeBetMinOdd || activeFreeBet.minOdd))) : partnerWageringOdd ? (React.createElement("span", { className: 'bet-button-title free-bet' },
        " ", " ".concat(t(MinOdd), " x").concat(partnerWageringOdd),
        " ")) : null;
    useEffect(function () {
        if (!localRefIsDoBet.current && isClosedDoBet) {
            // @ts-ignore
            localRefIsDoBet.current = isClosedDoBet;
        }
    }, [isClosedDoBet]);
    return (React.createElement("div", { className: 'aviabet-bet-button-wrp' },
        React.createElement("button", { className: "bet-button bet ".concat(dynamicClassName, " ").concat(disabled, " "), onClick: function () {
                if (localRefIsDoBet.current)
                    return;
                handleDoBetEvents(sectionIndex);
            }, onMouseDown: function () {
                if (localRefIsDoBet.current) {
                    // @ts-ignore
                    localRefIsDoBet.current = false;
                }
            }, onKeyDown: function (e) {
                if (disabled)
                    e.preventDefault();
            } },
            React.createElement("p", { className: 'bet-button-title' }, "".concat(t(betBtnText), " ").concat(freeBetRemainingCount, " ")),
            isLoaderActive && React.createElement("span", { className: 'circle-loader' }),
            isBetAccepted && !disabled && React.createElement(AccumulatedPossibleWin, { sectionIndex: sectionIndex }),
            additionalBtnInfo)));
});

export { BetButton };
